import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=19ef6782&scoped=true&"
import script from "./ItemView.vue?vue&type=script&lang=ts&"
export * from "./ItemView.vue?vue&type=script&lang=ts&"
import style0 from "./ItemView.vue?vue&type=style&index=0&id=19ef6782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef6782",
  null
  
)

export default component.exports